import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from '../directives/module';
import { LocalOffersApiService } from './services/local-offers-api-service';
import { LocalOffersEdit } from './components/edit/component';
import { OffersList } from './components/list/component';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        DirectivesModule,
        AppRoutingModule
    ],
    declarations: [LocalOffersEdit, OffersList],
    exports: [OffersList],
    providers: [LocalOffersApiService, {provide: MAT_DATE_LOCALE, useValue: 'en-GB'}],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class LocalOffersModule {}